import { render, staticRenderFns } from "./AccountPreferences.vue?vue&type=template&id=580e8e14&scoped=true&"
import script from "./AccountPreferences.vue?vue&type=script&lang=js&"
export * from "./AccountPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AccountPreferences.vue?vue&type=style&index=0&id=580e8e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e8e14",
  null
  
)

export default component.exports